import router from "@/router.js";
import utils from "@/utils";

export const GLOBAL_BASE_URL = "https://bolica.com";
export const GLOBAL_API_URL = "https://api.bolica.com";

const urlForMoblie = "http://192.168.1.190";
function getBaseApiUrl() {
  if (process.env.NODE_ENV == "debug") return "http://localhost:3000";
  if (process.env.NODE_ENV == "mobile") return urlForMoblie + ":3000";

  return GLOBAL_API_URL;
}
function getBaseUrl() {
  if (process.env.NODE_ENV == "debug") return "http://localhost:8080";
  if (process.env.NODE_ENV == "mobile") return urlForMoblie + ":8080";

  return GLOBAL_BASE_URL;
}

export const BASE_API_URL = getBaseApiUrl();

export const BASE_URL = getBaseUrl();

function asId(obj) {
  if (obj.id) return obj.id;
  return obj;
}

const urlManager = {
  getCardUrl: function(card) {
    return `${BASE_URL}/b/${card.board_id}/c/${card.in_board_id}`;
  },

  getListUrl: function(list) {
    return `${BASE_URL}/b/${list.board_id}/list/${list.id}`;
  },

  getBoardUrl: function(board) {
    return `${BASE_URL}/b/${board.id}`;
  },

  getEditBoardUrl: function(board) {
    return `${BASE_URL}/b/${board.id}/edit`;
  },

  getBoardId: function() {
    if (router.currentRoute.params.boardId) {
      return parseInt(router.currentRoute.params.boardId);
    }
    return null;
  },

  getBoardAction: function() {
    return router.currentRoute.params.boardAction;
  },

  getListId: function() {
    if (router.currentRoute.params.listId) {
      return parseInt(router.currentRoute.params.listId);
    }
    return null;
  },

  getCardId: function() {
    if (router.currentRoute.params.cardId) {
      return parseInt(router.currentRoute.params.cardId);
    }
    return null;
  },

  /** if we are already on this board, don't change url */
  toBoardIdNeeded: function(board) {
    if (!board) return;

    const boardId = asId(board);
    if (boardId == this.getBoardId()) {
      return;
    }

    let url = "/b/" + boardId;
    if (router.currentRoute.params.inBoardId) {
      url += "/c/" + router.currentRoute.params.inBoardId;
    }
    if (utils.isDebug()) {
      console.log(`change url from ${router.currentRoute.fullPath} to '${url}'`, board);
    }
    router.push(url);
  },

  toCurrentBoard: function() {
    if (!this.getBoardId()) {
      router.push("/");
    } else {
      router.push("/b/" + this.getBoardId());
    }
  },

  toEditBoard: function(board) {
    if (!board) return;

    const boardId = asId(board);
    let url = "/b/" + boardId + "/edit";
    router.push(url);
  },

  toEditList: function(list) {
    if (!list || !list.id) return;

    let url = `/b/${list.board_id}/list/${list.id}`;
    router.push(url);
  },

  toEditCard: function(card) {
    if (!card || !card.in_board_id) return;

    let url = `/b/${card.board_id}/c/${card.in_board_id}`;
    router.push(url);
  }
};

export default urlManager;
